var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.821,
    height: 50.072,
    viewBox: "0 0 41.821 50.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_28",
    "data-name": "Intersection 28",
    d: "M20.5,50.072l-.158-.043C20.136,49.973,0,44.285,0,28.506V.323L41.821,0V27.715c0,17.526-20.952,22.276-21.164,22.322ZM1.338,1.651V28.506c0,14.037,17.34,19.63,19.2,20.187,1.9-.466,19.95-5.322,19.95-20.977V1.348ZM4.331,26.792A16.444,16.444,0,0,1,29.763,13.018a.681.681,0,1,1-.746,1.139,15.091,15.091,0,1,0,5.639,6.728.681.681,0,1,1,1.253-.536,16.3,16.3,0,0,1,1.316,6.443,16.447,16.447,0,1,1-32.894,0ZM20.5,35.214a2.751,2.751,0,0,1-2.159-1.066l-6.7-8.705a2.731,2.731,0,1,1,4.328-3.333l.658.853c.017-.016.027-.037.045-.052a6.474,6.474,0,0,1,7.581-.134.659.659,0,0,1,.193.208l8.627-11.07a2.731,2.731,0,0,1,4.309,3.358L22.661,34.161a2.713,2.713,0,0,1-2.154,1.053ZM12.97,22.692a1.369,1.369,0,0,0-.249,1.919l6.7,8.706a1.372,1.372,0,0,0,1.08.534l.005.682v-.682a1.36,1.36,0,0,0,1.079-.527l14.72-18.888a1.371,1.371,0,0,0-.239-1.921,1.369,1.369,0,0,0-1.921.237l-13.094,16.8a.728.728,0,0,1-.539.263.682.682,0,0,1-.537-.266l-5.088-6.609a1.371,1.371,0,0,0-1.92-.249ZM17.492,24c-.015.011-.033.016-.049.026l3.077,4,3.151-4.042a.693.693,0,0,1-.194-.083,5.187,5.187,0,0,0-5.984.1Zm.764-5.173a2.3,2.3,0,1,1,2.3,2.3A2.3,2.3,0,0,1,18.256,18.827Zm1.363,0a.936.936,0,1,0,.936-.937A.938.938,0,0,0,19.619,18.827Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyze);
export default __webpack_public_path__ + "static/media/analyze.77342f85e5ccf3f1b1bf7c10df0423d6.svg";
export { ForwardRef as ReactComponent };